import React, { useState } from "react";
import PropTypes from "prop-types";
import capitalize from "capitalize";
import Modal from "@shared/v2/Modal";
import { UserSolidV6 } from "@shared/v2/Icomoon";
import BaseEvent from "./BaseEvent";

const TimelineLeadCreateUserNotificationEvent = ({ event, event: { timeline_fields: timelineFields } }) => {
  const [showModal, setShowModal] = useState(false);

  const details = Object.keys(timelineFields).map((key) => {
    if (["name", "full name"].includes(key)) return null;
    const titleizedKey = key
      .split("_")
      .map((element) => capitalize(element))
      .join(" ");
    return (
      <div key={key}>
        {titleizedKey}: {timelineFields[key]}
      </div>
    );
  });

  const leadName = timelineFields.name || "No name";

  return (
    <BaseEvent
      title={
        <div>
          <span className="tw-font-semibold">{leadName} </span>
          became a new contact
        </div>
      }
      icon={<UserSolidV6 />}
      interactedAt={event.interacted_at_absolute}
      onClick={() => setShowModal(true)}
    >
      {details}
      <Modal
        dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
        contentClassName="tw-max-w-[480px] tw-w-full tw-max-h-[90vh] tw-flex tw-flex-col tw-gap-[32px]"
        show={showModal}
        onHide={() => setShowModal(false)}
      >
        <Modal.Header title="Contact Added" closeButton />
        <Modal.Body>
          <div>
            <span className="tw-font-semibold">{leadName} </span>
            became a new contact
          </div>
          <div className="tw-font-semibold">Details:</div>
          {details}
        </Modal.Body>
      </Modal>
    </BaseEvent>
  );
};

TimelineLeadCreateUserNotificationEvent.propTypes = {
  event: PropTypes.shape().isRequired,
};

export default TimelineLeadCreateUserNotificationEvent;
